// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "clsx", "tailwind-merge"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("clsx"), require("tailwind-merge"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.clsx, global.tailwindMerge);
    global.utils = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _clsx, _tailwindMerge) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.cn = cn;
  _exports.ensureUnreachable = ensureUnreachable;
  function cn() {
    for (var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++) {
      inputs[_key] = arguments[_key];
    }
    return (0, _tailwindMerge.twMerge)((0, _clsx.clsx)(inputs));
  }
  function ensureUnreachable(value, message) {
    throw new Error(message !== null && message !== void 0 ? message : "Unreachable code hit with value ".concat(String(value)));
  }
});
